module.exports = __webpack_public_path__ + "img/browsers-inception-3.1398e1d5.png";